import { Query, QueryClient } from '@tanstack/react-query'
import { OPERATIONAL_EVENT_QUERY_KEY } from 'api/events/events.constants'

/**
 * Refetch the operational-event queries; one still fetching is refetched once its fetch lands.
 *
 * TanStack's default invalidation cancels the in-flight fetch instead, which never lets a fetch
 * land while invalidations arrive faster than it completes.
 */
export function refetchOperationalEventsAfterInFlight(queryClient: QueryClient): void {
  const family = { queryKey: [OPERATIONAL_EVENT_QUERY_KEY] }
  void queryClient.invalidateQueries({ ...family, refetchType: 'none' })
  for (const query of queryClient.getQueryCache().findAll({ ...family, type: 'active' })) {
    refetchAfterInFlight(queryClient, query)
  }
}

function refetchAfterInFlight(queryClient: QueryClient, query: Query): void {
  const onlyThis = { queryKey: query.queryKey, exact: true }
  if (query.state.fetchStatus === 'idle') {
    void queryClient.refetchQueries(onlyThis)
    return
  }
  void queryClient
    .refetchQueries(onlyThis, { cancelRefetch: false })
    .then(() => queryClient.refetchQueries(onlyThis, { cancelRefetch: false }))
}
